export default __webpack_public_path__ + "static/media/quinten-de-graaf-L4gN0aeaPY4-unsplash Large.7a6bef34.jpg";